import { BrowserImage } from "@vibrant/image-browser";
import { Vibrant } from "./config";

Vibrant.DefaultOpts.ImageClass = BrowserImage;

export { Vibrant };
